export default function Introduction({name = "", brief=""}){
  return (
      <div class="sm:flex justify-center">
          <div class={ "bg-white bg-opacity-95 block p-6 bg-white rounded-lg shadow-sm mt-8 max-w-7xl w-full" }>
              <h1 className="text-3xl mb-2 font-bold fade-in-up">
                  {name}
              </h1>

              <p class="px-8 whitespace-pre-wrap text-xl" dangerouslySetInnerHTML={{ __html: brief }}/>
          </div>

      </div>
  );

};